module.exports = __webpack_public_path__ + "static/img/loginimg.1aee519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginimg.png
// module id = 7GWL
// module chunks = 190